import { render } from "./AdminTabs.vue?vue&type=template&id=2f75c3fe"
import script from "./AdminTabs.vue?vue&type=script&lang=js"
export * from "./AdminTabs.vue?vue&type=script&lang=js"

import "./AdminTabs.vue?vue&type=style&index=0&id=2f75c3fe&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__